import classes from "./formTextarea.module.css";

export const FormTextarea = ({
  id,
  label,
  rows = 4,
  register,
  validation = {},
  disabled = false,
  readOnly = false,
  value,
  onChange,
  required = false,
}) => {
  const isRHF = !!register;

  return (
    <div className={classes.wrapper}>
      <div
        className={`${classes.inputBox} ${readOnly ? classes.readOnlyBox : ""}`}
      >
        <textarea
          id={id}
          rows={rows}
          readOnly={readOnly}
          disabled={disabled}
          className={classes.textarea}
          placeholder=" "
          {...(isRHF ? register(id, validation) : {})}
          {...(!isRHF && {
            value: value ?? "",
            onChange,
          })}
        />

        <label htmlFor={id} className={classes.floatingLabel}>
          {label}
          {required && <span className={classes.asterisk}>*</span>}
        </label>
      </div>
    </div>
  );
};